import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

import MaleIcon from "../../assets/MaleIcon.svg";
import FemaleIcon from "../../assets/FemaleIcon.svg";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CallTwoToneIcon from "@mui/icons-material/CallTwoTone";
import EmailTwoToneIcon from "@mui/icons-material/EmailTwoTone";
import CalendarMonthTwoToneIcon from "@mui/icons-material/CalendarMonthTwoTone";
import AccessTimeTwoToneIcon from "@mui/icons-material/AccessTimeTwoTone";
import LocationOnTwoToneIcon from "@mui/icons-material/LocationOnTwoTone";
import DeleteIcon from "@mui/icons-material/Delete";

import { Image } from "react-bootstrap";

import {
	Button,
	Checkbox,
	Backdrop,
	CircularProgress,
	Alert,
} from "@mui/material";
import { LabsCoupon } from "./couponDialog";

import { useState } from "react";
import { labsDetails } from "../../constants/constant";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import moment from "moment/moment";
import DependantHeaderSample from "../common/dependantHeaderSample";
import WalletOTP from "../otp/wallet";
import { FileUploadDialog } from "./fileUpload";
import { ApplyLabsCoupon, paymentMethod } from "../../services/wapi";

export const LabsPayment = () => {
	const history = useHistory();

	if (!labsDetails?.checkoutInfo?.checkoutItems?.length) {
		history.push("/checkout");
	}

	const [showCouponPopup, setShowCouponPopup] = useState(false);
	const [isLoading, setLoading] = useState(false);
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState("");

	const [user, setUser] = useState({
		shortToken: localStorage.getItem("user_short_token"),
	});

	const appointmentDateObj = moment(
		labsDetails?.checkoutInfo?.providerInfo?.prefDateTime,
	);
	const appointmentDate = {
		date: appointmentDateObj.format("MMM DD, YYYY"),
		time: appointmentDateObj.format("hh:mm A"),
	};
	const selectedBenef = JSON.parse(localStorage.getItem("selectedBenef"));

	const benefDetails = {
		gender:
			labsDetails.checkoutInfo.checkoutItems[0].gender == "Male" ||
			labsDetails.checkoutInfo.checkoutItems[0].gender == "M"
				? "M"
				: "F",
		dob: moment(
			Number(
				labsDetails.checkoutInfo.checkoutItems[0].dateOfBirth.replace(
					"/Date(",
					"",
				),
			),
		).format("MMM, dd YYYY"),
		name: labsDetails.checkoutInfo.checkoutItems[0].patientName,
		relation: labsDetails.checkoutInfo.checkoutItems[0].relation,
	};
	benefDetails.age = moment().diff(benefDetails.dob, "years");

	const staticPricing = {
		totalPrice: labsDetails.checkoutInfo.checkoutItems.reduce(
			(sum, item) => sum + item.itemPrice,
			0,
		),
		totalPriceRange: labsDetails.checkoutInfo.checkoutItems.reduce(
			(sum, item) => sum + (item.itemPriceRange || item.itemPrice * 1.35),
			0,
		),
		labsDiscount: 0,
	};
	staticPricing.labsDiscount =
		staticPricing.totalPriceRange - staticPricing.totalPrice;

	const [couponInfo, setCouponInfo] = useState({});

	const [finalPrice, setFinalPrice] = useState(staticPricing.totalPrice);
	const [priceWithoutWallet, setPriceWithoutWallet] = useState(
		staticPricing.totalPrice,
	);
	const [itemPrice, setItemPrice] = useState(staticPricing.totalPrice);

	const eligibleWalletMethods = [
		"PGAndMAWallet",
		"PGAndCorpWallet",
		"PGAndMBWallet",
	];

	const maidBalanceDetails =
		labsDetails.checkoutInfo.walletBalaceDetail?.filter(
			(x) =>
				!x.maid || x.maid == labsDetails.checkoutInfo.checkoutItems[0].maid,
		);

	const paymentLinkPhoneNumber =
		labsDetails.checkoutInfo.paymentLinkPhoneNumber;

	const walletInfo =
		maidBalanceDetails?.length &&
		!labsDetails.checkoutInfo.isRXVerificationRequired
			? labsDetails.checkoutInfo.paymentOptions
					.sort(
						(x, y) =>
							eligibleWalletMethods.indexOf(x.paymentMethod) -
							eligibleWalletMethods.indexOf(y.paymentMethod),
					)
					.filter((x) => eligibleWalletMethods.includes(x.paymentMethod))
					.map((x) => {
						return {
							paymentMethod: x.paymentMethod,
							name: x.walletName,
							deduction: x.walletAmount,
							availableAmount:
								maidBalanceDetails.find((y) => y.walletName == x.walletName)
									?.balance ?? 0,
						};
					})
			: [];

	const [selectedWallet, setSelectedWallet] = useState(null);

	const [walletVerification, setWalletVerification] = useState(false);

	const [fileUploadPopup, setFileUploadPopup] = useState(false);
	const [showDocCallNote, setShowDocCallNote] = useState(false);

	const toggleWallet = (checked, wallet) => {
		setShowAlert(false);
		setAlertMessage("");	
		if (!wallet) return;

		setShowDocCallNote(checked);

		if (!couponInfo?.couponCode) {
			calculateFinalPrice(couponInfo, checked ? wallet : null);
			return;
		}
		setLoading(true);
		ApplyLabsCoupon(
			{
				couponCode: couponInfo.couponCode,
				paymentMethod: checked ? wallet.paymentMethod : "PG",
			},
			user.shortToken,
		)
			.then((res) => {
				if (!res?.isSuccess) {
					throw new Error(res?.message);
				}
				calculateFinalPrice(res.response, checked ? wallet : null);
			})
			.catch((err) => {
				calculateFinalPrice(null, checked ? wallet : null);
				setShowAlert(true);
				setAlertMessage(err.message);
			})
			.finally(() => setLoading(false));
	};

	// toggleWallet(true, walletInfo?.[0]);

	const onCouponSuccess = (discountInfo) => {
		setShowAlert(false);
		setAlertMessage("");	
		calculateFinalPrice(discountInfo, selectedWallet);
	};

	const onCouponRemoval = () => {
		setShowAlert(false);
		setAlertMessage("");	
		calculateFinalPrice(null, selectedWallet);
	};

	const calculateFinalPrice = (discountInfo, wallet) => {
		let finalPrice = itemPrice;

		let discountAmount = 0;
		if (discountInfo?.discount) {
			discountAmount += discountInfo.discount;
			finalPrice -= discountInfo.discount;

			if (finalPrice < 0) {
				discountAmount += finalPrice;
				finalPrice = 0;
			}

			setCouponInfo({ ...discountInfo, appliedDiscount: discountAmount });
		} else {
			setCouponInfo({});
		}

		setPriceWithoutWallet(finalPrice);

		let walletDeduction = 0;
		if (wallet?.deduction) {
			walletDeduction += wallet.deduction;
			finalPrice -= wallet.deduction;

			if (finalPrice < 0) {
				walletDeduction += finalPrice;
				finalPrice = 0;
			}

			setSelectedWallet(
				walletDeduction
					? { ...wallet, appliedDeduction: walletDeduction }
					: null,
			);
		} else {
			setSelectedWallet(null);
		}

		setFinalPrice(finalPrice);
	};

	const setPricingProps = (amount, setter) => {
		setter(amount || 0);
	};

	const handlePayClick = async () => {
		if (
			selectedWallet?.appliedDeduction &&
			labsDetails?.checkoutInfo?.isRXRequired &&
			!labsDetails?.uploadedFiles?.length &&
			selectedBenef?.isUpsellRxVerificationEnabled
		) {
			setFileUploadPopup(true);

			return;
		}

		if (selectedWallet?.appliedDeduction && !labsDetails.walletVerified) {
			setWalletVerification(true);

			return;
		}

		await proceedWithPayment();
	};

	const proceedWithPayment = async () => {
		try {
			setLoading(true);
			const phleboDetails = JSON.parse(
				localStorage.getItem("user_details") ?? "{}",
			);

			const payload = {
				paymentMethods: [
					selectedWallet?.appliedDeduction
						? selectedWallet.paymentMethod
						: "PG",
				],
				uploadedFiles: labsDetails?.uploadedFiles ?? [],
				phoneNumber: paymentLinkPhoneNumber,
				patientName: labsDetails?.checkoutInfo?.checkoutItems?.[0]?.patientName,
				phleboId: phleboDetails?.phleboId,
			};

			if (couponInfo?.couponCode) payload.couponCode = couponInfo.couponCode;

			const response = await paymentMethod(payload, user.shortToken);

			if (!response.isSuccess) throw new Error();

			history.push("/upsellOrders");
		} catch (ex) {
			alert("Something went wrong. Please try again");
			history.push("/checkout");
		} finally {
			setLoading(false);
		}
	};

	const fileUploadSuccessHanlder = async (guids) => {
		labsDetails.uploadedFiles = guids;

		await handlePayClick();
	};

	const walletVerificationSuccessHandler = async () => {
		labsDetails.walletVerified = true;

		await proceedWithPayment();
	};

	const getPaymentDetails = () => {
		return {
			totalAmount: priceWithoutWallet,
			payableByWallet: selectedWallet?.appliedDeduction
		}
	}

	return (
		<>
			<div className="order-details-dashboard p-b-10">
				<div>
					<div className="header-sample">
						<i
							className="fa fa-chevron-circle-left"
							onClick={() => history.push("/checkout")}
						></i>
					</div>
					<DependantHeaderSample
						titleCall={true}
						noCall={true}
						title="Create Order"
					></DependantHeaderSample>
				</div>

				<Backdrop open={isLoading} sx={{ zIndex: 99999 }}>
					<CircularProgress />
				</Backdrop>

				<div className="p-3 labs-payment">
					<Accordion>
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<strong>Appointment Details</strong>
						</AccordionSummary>
						<AccordionDetails>
							<>
								<div className="d-flex align-items-center my-2">
									<CallTwoToneIcon fontSize="small" className="mr-1" />
									<span>{labsDetails.checkoutInfo.contactInfo.phone}</span>
								</div>
								<div className="d-flex align-items-center my-2">
									<EmailTwoToneIcon fontSize="small" className="mr-1" />
									<span>{labsDetails.checkoutInfo.contactInfo.email}</span>
								</div>
								<div className="d-flex align-items-center my-2">
									<CalendarMonthTwoToneIcon fontSize="small" className="mr-1" />
									<span className="mr-3">{appointmentDate.date}</span>
									<AccessTimeTwoToneIcon fontSize="small" className="mr-1" />
									<span>{appointmentDate.time}</span>
								</div>
								<div className="my-2">
									<LocationOnTwoToneIcon fontSize="small" className="mr-1" />
									<span>
										{`${labsDetails.checkoutInfo.contactInfo.addressLine1}, ${labsDetails.checkoutInfo.contactInfo.addressLine2}`}
									</span>
								</div>
							</>
						</AccordionDetails>
					</Accordion>

					<Accordion>
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<strong>Order Details</strong>
						</AccordionSummary>
						<AccordionDetails>
							<div className="d-flex align-items-center my-3">
								<Image
									src={benefDetails.gender == "F" ? FemaleIcon : MaleIcon}
									height="50"
									className="mr-3"
								/>
								<div>
									<div className="bold">{benefDetails.name}</div>
									<small>{`${benefDetails.relation}, ${benefDetails.gender}, ${benefDetails.age}`}</small>
								</div>
							</div>
							{labsDetails.checkoutInfo.checkoutItems.map((item, idx) => (
								<div
									key={idx}
									className="d-flex justify-content-between my-3 bold"
								>
									<small className="bold mr-3">{item.packageName}</small>
									<small className="text-nowrap">₹ {item.itemPrice}/-</small>
								</div>
							))}
						</AccordionDetails>
					</Accordion>

					<div className="my-5">
						<Button
							variant={couponInfo.couponCode ? "contained" : "outlined"}
							color={couponInfo.couponCode ? "success" : "primary"}
							fullWidth
							onClick={() =>
								couponInfo.couponCode
									? onCouponRemoval()
									: setShowCouponPopup(true)
							}
						>
							{couponInfo.couponCode || "Apply Coupon"}
							{couponInfo.couponCode && <DeleteIcon className="ml-3" />}
						</Button>
					</div>

					<div className="my-5">
						<div className="bold mb-2">Bill Summary</div>
						<div
							className="p-3 border border-dark"
							style={{ borderRadius: "10px" }}
						>
							<div className="d-flex justify-content-between mb-2">
								<div>MRP Total</div>
								<div>₹ {staticPricing.totalPriceRange.toFixed(2)}/-</div>
							</div>
							<div
								style={{ color: "#739508" }}
								className="d-flex justify-content-between mb-2"
							>
								<div>Lab Discount</div>
								<div> - ₹ {staticPricing.labsDiscount.toFixed(2)}/-</div>
							</div>
							{couponInfo?.couponCode && (
								<div
									style={{ color: "#ea9500" }}
									className="d-flex justify-content-between mb-2"
								>
									<div>Coupon Discount</div>
									<div> - ₹ {couponInfo.appliedDiscount.toFixed(2)}/-</div>
								</div>
							)}

							<div className="border-bottom mb-2"></div>
							<div className="d-flex justify-content-between bold">
								<div>Payable Amount</div>
								<div>
									₹{priceWithoutWallet.toFixed(2)}
									/-
								</div>
							</div>
						</div>
					</div>

					{walletInfo?.length ? (
						<div className="my-5">
							<div className="bold mb-2">Payment Details</div>
							<div
								className={`p-3 border border-dark ${
									!priceWithoutWallet && "grey-out"
								}`}
								style={{ borderRadius: "10px" }}
							>
								{walletInfo?.length &&
									walletInfo.map((wallet, idx) => (
										<div
											key={idx}
											className="d-flex justify-content-between mb-2"
										>
											<div className="d-flex align-items-center">
												<Checkbox
													disabled={!priceWithoutWallet}
													checked={selectedWallet?.name == wallet.name}
													onChange={(e) =>
														toggleWallet(e.target.checked, wallet)
													}
												/>
												<div>
													<div>{wallet.name}</div>
													<small>
														Available Balance: {wallet.availableAmount}
													</small>
												</div>
											</div>
											{selectedWallet?.name == wallet.name && (
												<div style={{ color: "#739508" }}>
													- ₹ {selectedWallet.appliedDeduction.toFixed(2)}/-
												</div>
											)}
										</div>
									))}

								<div className="border-bottom mb-2"></div>
								<div className="mb-2 d-flex justify-content-between bold">
									<div>Payable Amount</div>
									<div> ₹ {finalPrice.toFixed(2)}/-</div>
								</div>

								{selectedBenef?.isUpsellRxVerificationEnabled  && showDocCallNote && (
									<div className="pt-2 border-top">
										<p className="mb-0"> <strong>Note:</strong> As per the corporate policy, the patient must accept a MANDATORY but Free Doctor Call to avail their Cashless benefits.</p>
									</div>
								)}
							</div>
						</div>
					) : null}

					<div className="fixed-footer-container">
						<button
							type="button"
							className="btn btn-primary"
							onClick={handlePayClick}
						>
							{finalPrice
								? `Pay ${finalPrice.toFixed(2)}/-`
								: selectedWallet?.appliedDeduction
								? `Pay ₹ ${selectedWallet.appliedDeduction.toFixed(2)}/- via Wallet`
								: "Proceed"}
						</button>
					</div>

					<LabsCoupon
						visible={showCouponPopup}
						setVisibility={setShowCouponPopup}
						onSuccess={onCouponSuccess}
						data={{
							shortToken: user.shortToken,
						}}
						selectedWallet={selectedWallet}
					/>

					{!isLoading && showAlert && (
						<Alert severity="error" sx={{ marginTop: "20px" }}>
							{alertMessage || "Could not process. Please try again"}
						</Alert>
					)}
				</div>
			</div>

			{walletVerification && (
				<WalletOTP
					visible={walletVerification}
					setVisibility={setWalletVerification}
					onSuccess={walletVerificationSuccessHandler}
					phone={labsDetails.checkoutInfo.contactInfo.phone}
					type={"Wallet_OTP"}
					packageDetails={labsDetails.checkoutInfo.checkoutItems}
					paymentDetails={getPaymentDetails()}
				/>
			)}

			{fileUploadPopup && (
				<FileUploadDialog
					visible={fileUploadPopup}
					setVisibility={setFileUploadPopup}
					onSuccess={(guids) => fileUploadSuccessHanlder(guids)}
				/>
			)}
		</>
	);
};
